import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core'

import { OmnichannelTimelineViewService } from '../../data/services/view/omnichannel-timeline-view.service'
import { ITimelineFilters } from '../../data/interfaces/timeline-filters.interface'
import { CLIENT_EVENT_CATEGORY_OPTIONS } from '../../data/constants/client-event-type.constant'

@Component({
  selector: 'app-omnichannel-timeline',
  templateUrl: './omnichannel-timeline.component.html',
  styleUrls: ['./omnichannel-timeline.component.scss'],
})
export class OmnichannelTimelineComponent implements OnInit, OnChanges, OnDestroy {
  @Input() clientId!: string

  events$ = this.viewService.events$
  loading$ = this.viewService.loading$
  loadingMore$ = this.viewService.loadingMore$

  filters: ITimelineFilters = { page: 1, limit: 50 }
  selectedCategories: string[] = []
  dateRange: Date[] | null = null
  categoryOptions = CLIENT_EVENT_CATEGORY_OPTIONS

  constructor(private viewService: OmnichannelTimelineViewService) {}

  ngOnInit(): void {
    if (this.clientId) this.viewService.load(this.clientId, this.filters)
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['clientId'] && this.clientId) this.viewService.load(this.clientId, this.filters)
  }

  ngOnDestroy(): void {
    this.viewService.clear()
  }

  onFilterChange(): void {
    this.filters = {
      ...this.filters,
      page: 1,
      typeIn: this.selectedCategories.map((c) => `${c}.*`),
      from: this.dateRange?.[0]?.toISOString(),
      to: this.dateRange?.[1]?.toISOString(),
    }
    this.viewService.reload(this.filters)
  }

  loadMore(): void {
    this.viewService.loadMore()
  }

  get hasMore(): boolean {
    return this.viewService.hasMore
  }

  markerClass(type: string): string {
    return `marker-${type.split('.')[0]}`
  }

  markerIcon(type: string): string {
    const map: Record<string, string> = {
      client: 'pi pi-user',
      channel: 'pi pi-share-alt',
      verification: 'pi pi-shield',
      quotation: 'pi pi-calculator',
      document: 'pi pi-file',
      funnel: 'pi pi-list',
      lease: 'pi pi-briefcase',
      close: 'pi pi-flag',
    }
    return map[type.split('.')[0]] ?? 'pi pi-circle'
  }
}
